<template>
    <div>
        <div class="filter-title d-flex align-items-center mb-1">
            <h5 v-if="filter.text" class="filter-title mb-0" v-text="filter.text" />

            <filter-label
                v-if="filter.value && !filter.noReset"
                @close="$emit('set-filter', null)"
                @click.stop.native
                class="ml-auto"
                :background-color="filter.backgroundColor"
                :color="filter.color"
                :text="text"
            />
        </div>

        <radio-input
            v-for="(option, idxx) in filter.options"
            :key="idxx"
            :data="option"
            :name="fKey"
            :value="filter.value"
            :id="fKey + idxx"
            @change="$emit('set-filter', $event)"
        />
    </div>
</template>

<script>
import filterMixin from './filter.mixin'

export default {
    mixins: [filterMixin],
    computed: {
        text() {
            return this.filter.options.find(
                el => el.value === this.filter.value
            ).label
        }
    }
}
</script>
